export interface TourStep {
  id: string;
  text: string;
  route: string;
  tab?: string;
  position?: 'top' | 'bottom' | 'left' | 'right' | 'center';
  offset?: { x: number; y: number };
}

export const TOUR_STEPS: TourStep[] = [
  // STEP 1
  {
    id: 'tour-location',
    text: "Start here. Pick your Location and Job.",
    route: '/recruit/forecast',
    position: 'right',
    offset: { x: 20, y: 0 }
  },
  // STEP 2 (Renamed 'Safe' to 'GOOD')
  {
    id: 'tour-zones',
    text: "Set your 'GOOD Zone'. Too low? Customers suffer. Too high? Employees quit because they can't get hours. Find the balance.",
    route: '/recruit/forecast',
    position: 'left'
  },
  // STEP 3 (Updated Graph Explanation)
  {
    id: 'tour-graph',
    text: "See your campaign's results here. The Demand (purple) line predicts how many employees you need and the Supply (cyan) line shows how many you will have. New hires are the green line.",
    route: '/recruit/forecast',
    position: 'bottom'
  },
  // STEP 4
  {
    id: 'tour-budget',
    text: "This is your lever. Drag the Budget Slider to see how spending money moves the Supply Line.",
    route: '/recruit/forecast',
    position: 'right'
  },
  // STEP 5
  {
    id: 'tour-optimize',
    text: "Don't want to guess? Click the Wand. We'll calculate the exact budget needed to hit your goal efficiently.",
    route: '/recruit/forecast',
    position: 'bottom'
  },
  // STEP 6 (NEW STEP - Combine Checkbox)
  {
    id: 'tour-combine-checkbox',
    text: "Click here to combine the new hires with your current employees to see the results.",
    route: '/recruit/forecast',
    position: 'left',
    offset: { x: 0, y: 0 }
  },
  // STEP 7
  {
    id: 'tour-heatmap',
    text: "Move the blue slider to preview every shift.",
    route: '/recruit/forecast',
    position: 'top'
  },
  // STEP 8 (Swapped - Manager First)
  {
    id: 'tour-manager',
    text: "Who is the hiring manager? Assign them here so they get the interview notifications.",
    route: '/recruit/campaigns/c4',
    tab: 'settings',
    position: 'center'
  },
  // STEP 9 (Swapped - Posting Second)
  {
    id: 'tour-posting',
    text: "Tell new employees about the job. This will take a few minutes, but we have pre-built questions to help.",
    route: '/recruit/campaigns/c4',
    tab: 'posting',
    position: 'center'
  },
  // STEP 10
  {
    id: 'tour-preview',
    text: "Finally, see what they see. Browse the pre-built mobile screens for Candidates and Managers.",
    route: '/recruit/campaigns/c4',
    tab: 'preview',
    position: 'center'
  }
];
